import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid, Icon, Menu, Message } from 'semantic-ui-react';
import { Loading } from 'react-lib/dist/components-es';
import { competenciesActions } from '../behavior/competencies';
import { useOnce } from 'react-lib/dist/hooks-es';

const RequiredCompetencyPage = ({ getRequiredCompetencies, requiredCompetencies, t, isLoading }) => {
  useOnce(() => {
    if (!requiredCompetencies) getRequiredCompetencies();
  });

  const getCompetency = competency => (
    <Menu.Item key={competency.details.competencyCode}>
      <a
        href={`${window.REACT_APP_COMPETENCY_PAGE_SEARCH_KEYWORD}${competency.details.individualCompetencyName}`}
        target="_blank"
      >
        {competency.details.individualCompetencyName}
      </a>
      {competency.isAboutToExpire ? t('required.competency.page.is.about.to.expire') : null}
    </Menu.Item>
  );

  let requiredCompetenciesRemaining = requiredCompetencies && requiredCompetencies.length > 0;

  return (
    <Grid stackable className="centered withTopMargin">
      <Grid.Row>
        <h3>{t('required.competency.page.title')}</h3>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column computer={6} tablet={10}>
          {requiredCompetenciesRemaining && (
            <>
              <Message color={'yellow'}>
                <Icon name="warning sign" />
                {t('required.competency.page.warning.todo.info')}
              </Message>
              <Message color={'yellow'}>
                <Icon name="warning sign" />
                {t('required.competency.page.warning.sync.info')}
              </Message>
            </>
          )}
          {!isLoading && requiredCompetencies && requiredCompetencies.length == 0 && (
            <Message color="green">
              <Icon name="warning sign" />
              {t('required.competency.page.success.no.courses')}
            </Message>
          )}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column computer={6} tablet={10}>
          <Loading isLoading={isLoading} />
          {requiredCompetenciesRemaining && (
            <Menu vertical fluid>
              {requiredCompetencies.map(c => getCompetency(c))}
            </Menu>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const mapStateToProps = state => ({
  ...state.competencies
});

const mapDispatchToProps = dispatch => ({
  getRequiredCompetencies: () => dispatch(competenciesActions.getRequiredCompetencies())
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(RequiredCompetencyPage);
